// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"2a686769","294":"f14d8bc4","712":"7abf1789","938":"84b654a5"}[chunkId] + ".chunk.js";
};